module.exports = __webpack_public_path__ + "img/home-btn-phone.4ca8e289.svg";